"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

require("./SubMenu.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SubMenu = function SubMenu(props) {
  var children = props.children,
      onRouteClick = props.onRouteClick,
      subRoutes = props.subRoutes,
      onMouseLeave = props.onMouseLeave,
      right = props.right,
      id = props.id,
      _props$userInfo = props.userInfo,
      userInfo = _props$userInfo === undefined ? false : _props$userInfo;
  var containerStyles = (0, _classnames2.default)({
    "header-sub-menu": true,
    "z-100": true,
    "pos-a": true,
    "fff-header-submenu-containter": true,
    right: right
  });
  var subMenuStyles = (0, _classnames2.default)({
    "pos-r": true,
    "fff-header-submenu": true,
    right: right
  });
  var userInfoStyles = (0, _classnames2.default)({
    "user-info": true,
    "fs-14": true
  });
  var highlightStyles = (0, _classnames2.default)({
    highlight: true,
    "pad-4": true,
    "mar-l-4": true,
    "fw-bold": true,
    active: userInfo.state === "ACTIVE",
    "fs-10": true
  });

  var createChild = function createChild(props) {
    return _react2.default.createElement(_react2.default.Fragment, {
      key: props.key
    }, props.component);
  };

  var preChildren = function preChildren() {
    return children.map(function (child) {
      if (child.placementIndex < 1 && child.id === id) {
        return createChild(child);
      }
    });
  };

  var postChildren = function postChildren() {
    return children.map(function (child) {
      if (child.placementIndex > 1 && child.id === id) {
        return createChild(child);
      }
    });
  };

  return _react2.default.createElement("div", {
    id: id,
    onMouseLeave: onMouseLeave,
    className: containerStyles
  }, _react2.default.createElement("div", {
    className: subMenuStyles
  }, _react2.default.createElement("i", {
    className: "material-icons pos-a"
  }, "arrow_drop_up"), children && preChildren(), userInfo && _react2.default.createElement("div", {
    className: userInfoStyles
  }, _react2.default.createElement("p", null, "My Plan: ", _react2.default.createElement("b", null, userInfo.planName), " ", _react2.default.createElement("span", {
    className: highlightStyles
  }, userInfo.state === "CANCELED" ? "WILL NOT RENEW" : userInfo.state)), !!userInfo.premium && _react2.default.createElement("p", null, _react2.default.createElement("i", {
    className: "fas fa-star"
  }), " Select Access")), _react2.default.createElement("ul", {
    className: "pad-0 mar-0"
  }, subRoutes.map(function (subItem) {
    return _react2.default.createElement("li", {
      key: subItem.route
    }, _react2.default.createElement("button", {
      className: "naked-button cur-pointer fs-14 w-100 ta-left",
      onClick: function onClick() {
        onRouteClick(subItem);
      }
    }, subItem.label));
  })), children && postChildren()));
};

exports.default = SubMenu;